// The one map from an issue's dashboard stage to its colour and its label, for
// the per-issue surfaces: the issue page's stage chip, the links panel's stage
// dot and the editor timeline's "entered / left" lines. Each used to carry a
// byte-identical private copy.
//
// Deliberately NOT shared with two look-alikes:
//   - `SteerGroup`'s `STAGE_META` colours `needs_input` with `--st-blocked`
//     (red, "this needs you") where this map uses `--st-backlog` (grey). That
//     is a product decision about the steering board, not a drift to unify.
//   - `SetupBanner` labels stages with its own `dashboard.setup.stage.*` keys.

import type { DashboardStage } from "@loom/shared/dashboard";

import type { MessageKey } from "../i18n/index.js";

/** The stage's colour token, as a CSS value (`var(--st-*)`). */
export const STAGE_VAR: Record<DashboardStage, string> = {
  needs_input: "var(--st-backlog)",
  planned: "var(--st-ready)",
  in_progress: "var(--st-progress)",
  review: "var(--st-review)",
  shipped: "var(--st-done)",
};

/** The stage's short label. */
export const STAGE_LABEL_KEY: Record<DashboardStage, MessageKey> = {
  needs_input: "dashboard.issueStage.needs_input",
  planned: "dashboard.issueStage.planned",
  in_progress: "dashboard.issueStage.in_progress",
  review: "dashboard.issueStage.review",
  shipped: "dashboard.issueStage.shipped",
};
